import { NotFound } from 'components/common/NotFound';
import BarGuideFeature from 'features/BarGuideInfo';
import CharacterSettingFeature from 'features/CharacterSetting';
import CourseOrderLimitFeature from 'features/CourseOrderLimit';
import DailyMenuFeature from 'features/DailyMenu';
import DefaultPanelFeature from 'features/DefaultPanel';
import DisplayControlGroup from 'features/DisplayControlGroup';
import MenuServingTimeFeature from 'features/MenuServingTime';
import OverlayFunctionFeature from 'features/OverlayFunction';
import ServiceMenuFeature from 'features/ServiceMenu';
import ShabuSukiyakiFeature from 'features/ShabuSukiyaki';
import VideoFunctionFeature from 'features/VideoFunction';
import WizardFeature from 'features/Wizard';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

export default function BusinessTypeFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${path}/bar-guide-list`} />
        </Route>
        <Route path={`${path}/bar-guide-list`} exact>
          <BarGuideFeature />
        </Route>
        <Route path={`${path}/display-control-group`} exact>
          <DisplayControlGroup />
        </Route>
        <Route path={`${path}/overlay-function`} exact>
          <OverlayFunctionFeature />
        </Route>
        <Route path={`${path}/daily-menu`} exact>
          <DailyMenuFeature />
        </Route>
        <Route path={`${path}/course-order-limit`} exact>
          <CourseOrderLimitFeature />
        </Route>
        <Route path={`${path}/service-menu`} exact>
          <ServiceMenuFeature />
        </Route>
        <Route path={`${path}/video-function`} exact>
          <VideoFunctionFeature />
        </Route>
        <Route path={`${path}/shabu-sukiyaki`} exact>
          <ShabuSukiyakiFeature />
        </Route>
        <Route path={`${path}/menu-serving-time`} exact>
          <MenuServingTimeFeature />
        </Route>
        <Route path={`${path}/default-panel`} exact>
          <DefaultPanelFeature />
        </Route>
        <Route path={`${path}/character-setting`} exact>
          <CharacterSettingFeature />
        </Route>
        <Route path={`${path}/wizard`} exact>
          <WizardFeature />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
